import { useEffect } from 'react'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { mergeRegister } from '@lexical/utils'
import { $getSelection, $isRangeSelection, $getRoot, $createParagraphNode } from 'lexical'
import { INSERT_INPUT } from '../commands'
import { InputNode } from '../nodes/inputNode'

export function InsertInputPlugin({ insertRef }) {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    const unregister = mergeRegister(
      editor.registerCommand(INSERT_INPUT, props => {
        editor.update(() => {
          const node = new InputNode(props)
          const selection = $getSelection()
          if ($isRangeSelection(selection)) {
            selection.insertNodes([node])
          } else {
            const root = $getRoot()
            let para = root.getLastChild()
            if (!para || para.getType() !== 'paragraph') {
              para = $createParagraphNode()
              root.append(para)
            }
            para.append(node)
          }
        })
        return true
      }, 0)
    )

    insertRef.current.insertInput = props => editor.dispatchCommand(INSERT_INPUT, props)
    insertRef.current.editor = editor

    return () => unregister()
  }, [editor, insertRef])

  return null
}
